export default __webpack_public_path__ + "static/sub-industry-slash-1a6b47967d6b7924a701e488534dc901.png";